import * as angular from 'angular';

import { IAccordionController } from './accordion-directive';

class AccordionPanelDirective implements angular.IDirective {
    readonly replace = true;
    readonly transclude = true;
    readonly restrict = 'E';

    readonly require = '^fcAccordion';
    readonly template = `
        <li
            class="fc-accordion-panel accordion-item"
            layout="column"
            data-accordion-item
            ng-transclude
        ></li>
    `;

    readonly link: angular.IDirectiveLinkFn;

    constructor() {
        this.link = this._link.bind(this);
    }

    private _link(
        _scope: angular.IScope,
        element: JQuery,
        _attributes: angular.IAttributes,
        accordion: IAccordionController
    ): void {
        accordion.registerPanel(element);
    }
}

const AccordionPanelDirectiveFactory: angular.IDirectiveFactory = () =>
    new AccordionPanelDirective();

export { AccordionPanelDirectiveFactory };
